// eslint-disable-next-line check-file/filename-naming-convention
import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@dotcom/crown-ui';
import '@dotcom/crown-ui/dist/esm/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import styles from './App.module.scss';
import { SFCCRedirect } from './components/sfcc-redirect';
import { ContextProvider } from './context';
import { InitializationDataContext } from './context/data-context';
import { PODRoutes } from './routes';
import { getCuiTheme } from './themes/get-cui-theme';
import { preventUnload } from './utils';

const queryClient = new QueryClient();

// If isUk, use UK Theme
const router = createBrowserRouter([
  {
    path: '/card/customization',
    element: <SFCCRedirect />,
  },
  ...PODRoutes.map(({ route, view: Element }) => ({
    path: `/card/customization${route}`,
    element: <Element />,
  })),
]);

const PrintOnDemand = () => {
  useEffect(() => {
    window.addEventListener('beforeunload', preventUnload);
  }, []);

  const theme = getCuiTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <ContextProvider>
        <InitializationDataContext.Consumer>
          {() => (
            <ThemeProvider theme={theme}>
              <div className={styles.app}>
                <RouterProvider router={router} />
              </div>
            </ThemeProvider>
          )}
        </InitializationDataContext.Consumer>
      </ContextProvider>
    </QueryClientProvider>
  );
};

export default PrintOnDemand;
